export const SENTRY_DSN = 'https://55e3156e3af64c85a3ee2fce5e94c055@o479791.ingest.sentry.io/6487433';
